import axiosMultipartInstance from "~/shared/api/axios-multipart-instance";

export const updateCameraImage = async (params: {
  branchUid: string;
  versionId?: number;
  cameraOrientationId: number;
  previewImage: File;
}) => {
  const formData = new FormData();
  formData.append("preview_img", params.previewImage);
  if (params.versionId != null) {
    formData.append("version", params.versionId.toString());
  }
  const { data } = await axiosMultipartInstance.patch(
    `branches/${params.branchUid}/pseudo-camera-orientations/${params.cameraOrientationId}/preview-img/`,
    formData,
  );
  return data;
};
